import _ from 'lodash';
import {FABRIC} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.fabricState, action) {
  switch (action.type) {
    case FABRIC.GET_LIST_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.count || 0};
    case FABRIC.RELOAD:
      return {...state, reload: !state.reload};
    case FABRIC.GET_DETAIL_SUCCESS:
      return {...state, detail: action.data};
    case FABRIC.RESET_DETAIL:
      return {...state, detail: {}};
    case FABRIC.GET_KEY_SUCCESS: {
      let properties = _.cloneDeep(state.properties);
      if (!_.isEmpty(action.data) && action.data.key) {
        _.set(properties, action.data.key, action.data.values || []);
      }
      return {...state, properties: properties};
    }
    default:
      return state;
  }
}
